module.exports = __webpack_public_path__ + "img/infrastructure-13.069c489e.png";